import styled from "styled-components";
import { PALETTE } from "../../styles/palette";

export const Dimmed = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${PALETTE.BLACK_900};
  opacity: 0.4;
`;

export const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Content = styled.div`
  z-index: 3;
  padding: 2rem;
`;
